/** */
import {DiffPanelBase} from "back/edit/wed/features/diffBar_";
import {DrfRefDiffAction, DrvDiffAction, HistoItemDiffAction, JDrfRefWedDiffBarParams, JDrvWedDiffBarParams, JHistoItemWedDiffBarParams, JOtherItemWedDiffBarParams, OtherItemDiffAction} from "back/wsp/widgets/wed/itemEditorExt";
import {IWedDiffBar} from "back/edit/wed/features/diffBar";
import {SrcPointer, SrcPointerErase, SrcPointerFastSelect, SrcPointerPaste} from "back/wsp/widgets/srcDrawer";
import {IWspUiEnv, WSP, wspCd} from "lib/wsp/wsp";
import {IReg, REG} from "lib/commons/registry";
import {ACTION, Action} from "lib/commons/actions";
import {IShortDescCtx, ITEM} from "lib/wsp/item";
import {JSrcFields, SRC, srcRef} from "lib/wsp/src";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {DOMSH} from "lib/commons/xml/domsh";
import {EXmlDiffMode, XmlDiffSession} from "lib/edit/schema/diff";
import {ButtonActions, ButtonToggle, OButtonToggleInit} from "back/commons/widgets/buttons";
import {DOM, JSX, ShadowJsx} from "lib/commons/xml/dom";
import {GFX} from "lib/commons/utils/gfx";
import {account} from "lib/core/user";
import {ArrowScrollBox} from "back/commons/widgets/scroll";
import {LOCALE} from "lib/commons/lang";
import {ITooltipPointer, POPUP, PopupTooltip} from "back/commons/widgets/popups";
import {IView} from "lib/commons/views";
import {OUserRefInit, UserRef} from "back/core/widgets/userRef";
import {BarActions, OBarActionsInit} from "back/commons/widgets/bars";
import "back/wsp/widgets/widgets_Perms";
import {ERROR} from "lib/core/errorReport";
import {WedMgr} from "back/edit/wed/wedEditor";
import {IWspXmlHouse} from "lib/wsp/wspsLive";
import {ItemIsolated} from "back/wsp/views/itemIsolated";
import ESpecialCandidateUri = WSP.ESpecialCandidateUri;


/**
 *
 */
export class DrfRefDiffPanel extends DiffPanelBase<IItemUiEnv> {

	action: DrfRefDiffAction;

	erased?: boolean

	initPanel(action: OtherItemDiffAction, bar: IWedDiffBar): this {
		this._initPanel(action, bar);
		this.shadowRoot.appendChild(this.result);
		this.execDiff();
		return this;
	}

	setDiff(params: JDrfRefWedDiffBarParams | undefined | null): void {
		this.erased = params === null;
		this.execDiff();
	}

	buildDiffParams(): JDrfRefWedDiffBarParams {
		return {diffId: this.action.getId()}
	}

	execDiff(fullRefresh?: boolean): Promise<void> {
		if (fullRefresh) this.erased = false;
		return callDiff(this.erased ? "" : "special:drf:ref", this, EXmlDiffMode.diff);
	}
}

REG.reg.registerSkin("wed-diff-drfref", 1, /* language=CSS */ `
	:host {
		display: flex;
		justify-content: center;
	}
`);

customElements.define("wed-diff-drfref", DrfRefDiffPanel);

/**
 *
 */
export class DrvDiffPanel extends DiffPanelBase<IItemUiEnv> {

	action: DrvDiffAction;

	erased?: boolean

	initPanel(action: OtherItemDiffAction, bar: IWedDiffBar): this {
		this._initPanel(action, bar);
		this.shadowRoot.appendChild(this.result);
		this.execDiff();
		return this;
	}

	setDiff(params: JDrvWedDiffBarParams | undefined | null): void {
		this.erased = params === null;
		this.execDiff();
	}

	buildDiffParams(): JDrvWedDiffBarParams {
		return {diffId: this.action.getId()}
	}

	execDiff(fullRefresh?: boolean): Promise<void> {
		if (fullRefresh) this.erased = false;
		return callDiff(this.erased ? "" : this.action.specialRef, this, EXmlDiffMode.diff);
	}
}

REG.reg.registerSkin("wed-diff-drv", 1, /* language=CSS */ `
	:host {
		display: flex;
		justify-content: center;
	}
`);

customElements.define("wed-diff-drv", DrvDiffPanel);

/**
 *
 */
export class HistoItemDiffPanel extends DiffPanelBase<IItemUiEnv> {

	reg: IReg<IItemUiEnv>;
	action: HistoItemDiffAction;
	protected fields: string;

	/** Source de diff à afficher.*/
	srcDiff?: srcRef;

	/** Point de la ligne d'histo correspondant à l'item courant. */
	currentPoint: HistoPoint;

	/** Point de la ligne d'histo actuellement comparée */
	diffPoint: HistoPoint | null;


	scrollLine: ArrowScrollBox;
	topLine: HTMLElement;
	middleLine: HTMLElement;
	bottomLine: HTMLElement;
	diffSelView: HTMLElement;

	protected userColors: Map<account, string> = new Map();
	protected colorOffset = 0;

	protected _tt: PopupTooltip;

	initPanel(action: HistoItemDiffAction, bar: IWedDiffBar): this {
		this._initPanel(action, bar);
		this.topLine = <div id="top"/>;
		this.middleLine = <div id="middle"/>;
		this.bottomLine = <div id="bottom"/>;
		this.diffSelView = <div id="sel"/>;
		this.scrollLine = <ArrowScrollBox>
			<div id="lines">
				{this.topLine}
				{this.middleLine}
				{this.bottomLine}
			</div>
		</ArrowScrollBox> as ArrowScrollBox;

		this.shadowRoot.append(
			this.scrollLine,
			<div id="states">
				{this.diffSelView}
				{this.result}
			</div>
		);
		this.fields = this.reg.env.wsp.getShortDescFields().concat("metaFlag", "metaComment").join('*');

		this.middleLine.addEventListener("keydown", this.onKeyDownInLine);
		this.middleLine.addEventListener("dblclick", this.onDblclickInLine);

		this.getColor(this.reg.env.securityCtx.account);//réserve la 1ère couleur pour le user courant.
		return this;
	}

	connectDoc(): void {
		super.connectDoc();
		this.updateHisto();
	}

	unconnectDoc(): void {
		super.unconnectDoc();
		this.resetHisto();
	}

	onViewShown() {
		//sur onViewShown / onViewHidden pour désabonnment des diff affichée dans les dialogs d'édition des metas du txt
		if (!this._onItemChange && this.reg.env.longDescChange) this.reg.env.longDescChange.add((this._onItemChange = this.onItemChange.bind(this)));
	}

	onViewHidden(closed?: boolean): void {
		if (closed && this.reg.env.longDescChange) this.reg.env.longDescChange.delete(this._onItemChange);
		this.closeTooltip();
	}

	onItemChange() {
		if (this.docConnected) this.updateHisto();
	}

	protected _onItemChange: () => void;

	async updateHisto(): Promise<void> {
		const hadFocus = this.matches(":focus-within");
		this.resetHisto();
		try {
			//const ld = this.reg.env.longDesc;
			const editedSrc = (this.wedMgr.docHolder.house as IWspXmlHouse).srcFields;
			const hist = await WSP.fetchHistory(this.reg.env.wsp, this, editedSrc.srcLiveUri || editedSrc.srcUri, this.fields);
			//console.log("::hist:::::", hist);

			const count = hist.histNodes.length;

			if (count <= 1) {
				this.middleLine.append("Aucune entrée d'historique disponible");
				//Entrée d'historique disparue, on efface
				this.srcDiff = null;
				this.execDiff();
				return;
			}

			const rect = this.topLine.parentElement.getBoundingClientRect();
			const h = Math.floor(rect.height / 3);
			const hHalf = h / 2;
			const w = Math.round(GFX.bound(h + 4, (rect.width - count) / (count + 1), h * 3));
			const wHalf = w / 2;
			const linePath = `M 0,${hHalf} H ${w}`;
			const rate = ((h - 2) / 14).toString();

			let nextOnTop = false;
			let nextWidthTop = 0;
			let nextWidthBottom = 0;

			//Recherche du current, 1er si pas trouvé
			const currentOffset = hist.histNodes.findIndex((src) => src.srcUri === editedSrc.srcUri);
			const currentDate = new Date(currentOffset >= 0 ? hist.histNodes[currentOffset].srcDt : Date.now());

			//Ajout flèche
			this.topLine.appendChild(<div/>);
			nextWidthTop += w;
			this.middleLine.appendChild(JSX.asSvg(() => <svg id="frontArrowEnd" width={w} height={h} fill="none" stroke-width="2" stroke="var(--alt2-color)">
				<path d={`M 0,${hHalf} H ${hHalf}`}/>
				<path d={`M 1,2 ${hHalf},${hHalf} 1,${h - 2}`}/>
			</svg>));
			this.bottomLine.appendChild(<div/>);
			nextWidthBottom += w;

			let srcDiffFound = false;
			let previousTime: string = "";
			for (let i = 0; i < hist.histNodes.length; i++) {
				const src = hist.histNodes[i];
				//Ajout de chaque noeud
				let srcTime: string;
				if (i === currentOffset) {
					if (nextWidthTop > 0) (this.topLine.lastElementChild as HTMLElement).style.width = nextWidthTop + "px";
					this.topLine.append(JSX.asSvg(() => <svg width={w} height={h}>
							<path transform={`translate(${wHalf - hHalf})`} d={`M 0,3 H ${h} L ${hHalf},${h}`} fill="var(--alt2-color)"/>
						</svg>),
						<div/>);
					nextWidthTop = 0;
					if (nextWidthBottom > 0) (this.bottomLine.lastElementChild as HTMLElement).style.width = nextWidthBottom + "px";
					this.bottomLine.append(JSX.asSvg(() => <svg width={w} height={h}>
							<path transform={`translate(${wHalf - hHalf})`} d={`M 0,${h - 3} H ${h} L ${hHalf},0`} fill="var(--alt2-color)"/>
						</svg>),
						<div/>);
					nextWidthBottom = 0;
					nextOnTop = !nextOnTop;
				} else {
					//Time
					srcTime = LOCALE.formatMinDuration(currentDate, new Date(src.srcDt), true, '+-');
					if (srcTime === previousTime) {
						//Pas de marque de temps
						srcTime = "";
						nextWidthTop += w;
						nextWidthBottom += w;
					} else {
						//Nouvelle marque de temps
						if (nextOnTop) {
							if (nextWidthTop > 0) (this.topLine.lastElementChild as HTMLElement).style.width = nextWidthTop + "px";
							this.topLine.appendChild(<wed-histo-time class={i > currentOffset ? "timeAfter" : "timeBefore"}>{srcTime}</wed-histo-time>);
							nextWidthTop = w;
							nextWidthBottom += w;
						} else {
							if (nextWidthBottom > 0) (this.bottomLine.lastElementChild as HTMLElement).style.width = nextWidthBottom + "px";
							this.bottomLine.appendChild(<wed-histo-time class={i > currentOffset ? "timeAfter" : "timeBefore"}>{srcTime}</wed-histo-time>);
							nextWidthBottom = w;
							nextWidthTop += w;
						}
						previousTime = srcTime;
						nextOnTop = !nextOnTop;
					}
				}

				//Middle
				const color = this.getColor(src.srcUser);
				const shape = JSX.asSvg(() => {
					if (ITEM.isHistoryUri(src.srcUri)) {
						src.srcLiveUri = hist.liveNode.srcUri; //enrichissement des entrées d'historique
						if (src.metaFlag > 0) {
							return <path transform={`matrix(${rate},0,0,${rate},${wHalf - hHalf},0)`} d="m 18.1,8.2 -5.25,2.25 0.7,5.3 L 9,12.35 4.76,15.6 5.43,9.93 0.5,7.9 5.74,5.65 5,0.35 9.6,3.77 13.83,0.5 13.2,6.18 Z" stroke-width="2" fill={color}
													 stroke="var(--alt2-color)"/>;
						} else {
							return <circle cx={wHalf} cy={hHalf} r={hHalf - 2} stroke-width="2" fill={color} stroke="var(--alt2-color)"/>;
						}
					} else if (src.metaFlag > 0) {
						return <g>
							<rect x={wHalf - hHalf + 1} y="0" width={h} height={h} fill="var(--alt2-color)"/>
							<path transform={`matrix(${rate},0,0,${rate},${wHalf - hHalf},0)`} d="m 18.1,8.2 -5.25,2.25 0.7,5.3 L 9,12.35 4.76,15.6 5.43,9.93 0.5,7.9 5.74,5.65 5,0.35 9.6,3.77 13.83,0.5 13.2,6.18 Z" fill={color}/>
						</g>
					} else {
						return <rect x={wHalf - hHalf + 1} y="1" width={h - 2} height={h - 2} stroke-width="2" fill={color} stroke="var(--alt2-color)"/>
					}
				});
				const point = <wed-histo-point>{JSX.asSvg(() => <svg width={srcTime ? w - 1 : w} height={h}>
					<path d={linePath} stroke-width="2" stroke="var(--alt2-color)"/>
					{shape}
					{src.metaComment ? <path transform={`matrix(${rate},0,0,${rate},${wHalf},0)`} d="M 1,5.7 5.8,0 8,1.9 3,7.4 0,9" fill="var(--alt1-color)"/> : undefined}
				</svg>)}</wed-histo-point> as HistoPoint;
				if (srcTime) point.classList.add(i > currentOffset ? "timeAfter" : "timeBefore");
				point.shortDesc = src;

				this.middleLine.appendChild(point);

				if (this.srcDiff && !srcDiffFound && SRC.srcRef(src) === this.srcDiff) {
					this._setDiffPoint(point);
					srcDiffFound = true;
				}
				if (i === currentOffset) this.currentPoint = point;
			}
			if (!srcDiffFound && this.srcDiff) {
				//Entrée d'historique disparue, on efface
				this.srcDiff = null;
				this.execDiff();
			}

			if (nextWidthTop > 0) (this.topLine.lastElementChild as HTMLElement).style.width = nextWidthTop + "px";
			if (nextWidthBottom > 0) (this.bottomLine.lastElementChild as HTMLElement).style.width = nextWidthBottom + "px";

			if (this.currentPoint) {
				this.currentPoint.focusable = true;
				this.scrollLine.scrollToChild(this.currentPoint);
				if (hadFocus) this.currentPoint.focus();
			}
		} catch (e) {
			ERROR.log(e);
		}
	}

	resetHisto() {
		this.topLine.textContent = null;
		this.middleLine.textContent = null;
		this.bottomLine.textContent = null;
	}

	onKeyDownInLine(this: HTMLElement, ev: KeyboardEvent) {
		if (ACTION.isAnyControlPressed(ev)) return;
		const histoPoint = ev.target as HistoPoint;
		switch (ev.key) {
		case "ArrowLeft":
			if (histoPoint.nextElementSibling instanceof HistoPoint) histoPoint.nextElementSibling.focus();
			break;
		case "ArrowRight":
			if (histoPoint.previousElementSibling instanceof HistoPoint) histoPoint.previousElementSibling.focus();
			break;
		case "Enter":
			histoPoint.click();
			break;
		default:
			return;
		}
		ev.preventDefault();
		ev.stopPropagation();
	}

	onDblclickInLine(this: HTMLElement, ev: MouseEvent) {
		const histoPoint = DOM.findParent(ev.target as Node, this, (n): n is HistoPoint => n instanceof HistoPoint);
		if (histoPoint) ShowHistoDiff.SINGLETON.executeIfAvailable(histoPoint, ev);
	}

	setCurrentTooltip(tt: PopupTooltip) {
		this._tt?.close();
		this._tt = tt;
	}

	closeTooltip(): void {
		if (this._tt) {
			this._tt.close();
			this._tt = null;
		}
	}

	async execDiff(fullRefresh?: boolean): Promise<void> {
		if (fullRefresh) await this.updateHisto();
		return callDiff(this.srcDiff, this, EXmlDiffMode.diff);
	}

	setDiff(params: JHistoItemWedDiffBarParams | null): void {
		this.setSrcDiff(params?.srcDiff);
	}

	setSrcDiff(srcDiff: srcRef): void {
		this.srcDiff = srcDiff;
		this.execDiff();
		let point: HistoPoint;
		if (this.middleLine.hasChildNodes()) {
			//line calculée
			for (let ch of this.middleLine.children) {
				if (ch instanceof HistoPoint && SRC.srcRef(ch.shortDesc) === srcDiff) {
					point = ch;
					break;
				}
			}
		}
		this._setDiffPoint(point);
	}

	setDiffPoint(histoPoint: HistoPoint): void {
		this._setDiffPoint(histoPoint);
		this.srcDiff = histoPoint ? SRC.srcRef(histoPoint.shortDesc) : null;
		this.execDiff();
	}

	protected _setDiffPoint(histoPoint: HistoPoint): void {
		this.diffPoint?.classList.remove("diff");
		if (histoPoint) {
			histoPoint.classList.add("diff");
			this.diffPoint = histoPoint;
			const dt = new Date(histoPoint.shortDesc.srcDt);
			const date = dt.toLocaleDateString("fr");
			const time = dt.toLocaleTimeString("fr");
			this.diffSelView.textContent = ITEM.isHistoryUri(histoPoint.shortDesc.srcUri) ?
				`Entrée du ${date} à ${time}` :
				"Item courant (${date} à ${time})";
		} else {
			this.diffSelView.textContent = null;
		}
	}

	buildDiffParams(): JHistoItemWedDiffBarParams {
		return {diffId: this.action.getId(), srcDiff: this.srcDiff}
	}

	protected getColor(a: account) {
		if (!a) return "white";
		let color = this.userColors.get(a);
		if (color) return color;
		color = COLORS[this.colorOffset++];
		this.userColors.set(a, color);
		if (this.colorOffset >= COLORS.length) this.colorOffset = 1; // pas 0, on saute la couleur du user courant.
		return color;
	}
}

const COLORS = ["#AAA", "#9370db", "#b22222", "#2e8b57", "#ff4500", "#3c64e6", "#ffe100", "#c99b61", "#b0e0e6", "#ff6293", "#9acd32", "#ffb6c1", "#20b2aa", "#0000c8", "#ffa500", "#789bf2", "#eedfb8", "#4d453a"];

REG.reg.registerSkin("wed-diff-histoitem", 1, /* language=CSS */ `
	:host {
		display: flex;
		flex-direction: column;
	}

	c-arrow-scroll-box {
		justify-content: end;
	}

	#lines {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 0 1em;
	}

	#top,
	#middle,
	#bottom {
		height: 1em;
		display: flex;
		flex-direction: row-reverse;
	}

	wed-histo-point {
		display: flex;
		justify-content: center;
		box-sizing: border-box;
	}

	wed-histo-point:hover,
	wed-histo-point.hover {
		outline: 2px dotted var(--border-color);
		cursor: pointer;
	}

	wed-histo-point:focus {
		outline: var(--focus-outline);
	}

	wed-histo-point.diff {
		background-color: var(--alt2-color);
	}

	wed-histo-point.timeAfter {
		border-inline-end: 1px solid var(--color);
	}

	wed-histo-point.timeBefore {
		border-inline-start: 1px solid var(--color);
	}

	wed-histo-time {
		box-sizing: border-box;
		font-size: 80%;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		padding: 0 1px;
		user-select: none;
	}

	wed-histo-time.timeAfter {
		text-align: end;
		border-inline-end: 1px solid var(--color);
	}

	wed-histo-time.timeBefore {
		border-inline-start: 1px solid var(--color);
	}

	#states {
		display: flex;
		height: 1.5em;
	}

	#sel {
		flex: 1 1 auto;
		margin: 0 1em;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}

	#result {
		flex: 1 2 auto;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		margin: 0 1em;
	}
`);

customElements.define("wed-diff-histoitem", HistoItemDiffPanel);


export class HistoPoint extends HTMLElement implements ITooltipPointer {
	shortDesc: JSrcFields;
	popupTooltip?: PopupTooltip;
	startBtn: ButtonToggle;
	commentInput: HTMLInputElement;

	constructor() {
		super();
		this.onclick = POPUP.promiseTooltip(this, this.onBuildTooltipPoint, {hoverAllowed: true});
		this.onblur = (ev: FocusEvent) => {
			if (this.popupTooltip && !DOM.isAncestor(this.popupTooltip, ev.relatedTarget as HTMLElement)) this.popupTooltip.close();
		}
	}

	get histoPanel(): HistoItemDiffPanel {return DOMSH.findHost<HistoItemDiffPanel>(this)}

	get focusable() {return this.tabIndex === 0}

	set focusable(f: boolean) {
		if (f) {
			for (let ch of this.parentElement.children) {
				if (ch !== this && ch.hasAttribute("tabindex")) ch.removeAttribute("tabindex");
			}
			this.tabIndex = 0;
		} else if (this.hasAttribute("tabindex")) {
			this.removeAttribute("tabindex");
		}
	}

	focus(options?: FocusOptions): void {
		this.focusable = true;
		super.focus(options);
		const scroll = DOM.findParent(this, null, (n): n is ArrowScrollBox => n instanceof ArrowScrollBox);
		scroll?.scrollToChild(this);
	}

	onBuildTooltipPoint(this: void, point: HistoPoint, tooltip: PopupTooltip): IView | null {
		//if (ITEM.isHistoryUri(point.shortDesc.srcUri)) {
		//point.focus();
		const panel = point.histoPanel;
		//console.log(":::onBuildTooltipPoint");
		const dt = new Date(point.shortDesc.srcDt);
		const date = dt.toLocaleDateString("fr");
		const time = dt.toLocaleTimeString("fr");
		const reg = panel.reg;
		const actionsBar = <BarActions î={{reg, actions: reg.getList("actions:item:histoEntry"), actionContext: point, disableFullOverlay: true} as OBarActionsInit<HistoPoint>}/>;
		tooltip.addEventListener("c-show", () => {
			point.classList.toggle("hover", true);
			panel.setCurrentTooltip(tooltip);
			Promise.resolve().then(() => {
				const focusbale = DOMSH.findFlatNext(actionsBar, actionsBar, DOM.IS_focusable);
				if (focusbale) focusbale.focus();
			});
		});
		tooltip.addEventListener("c-beforeclose", () => {
			point.classList.toggle("hover", false);
			panel.setCurrentTooltip(null);
		});
		point.startBtn = <ButtonToggle id="metaStar" î={{reg} as OButtonToggleInit} title="Lorsque l'entrée est marquée, elle est préservée des purges progressives automatiques">
			{JSX.asSvg(() => <svg width="16" height="16">
				<path id="star" stroke-width="1" d="M 11.35,13.56 8,11.1 4.6,13.56 5,9.4 1.2,7.73 5,6 4.56,1.84 7.95,4.33 11.35,1.84 10.9,6 14.75,7.73 10.9,9.43 Z"/>
			</svg>)}
		</ButtonToggle> as ButtonToggle;
		point.startBtn.toggleOn = point.shortDesc.metaFlag > 0;
		point.commentInput = <input id="metaComment" value={point.shortDesc.metaComment || ""} placeholder="Note..." title="Note associée à cette entrée dans l'historique"/> as HTMLInputElement;
		if (reg.hasPerm("action.wsp.histo#change.flag")) {
			point.startBtn.onclick = point.updateMetaFlag.bind(point);
		} else {
			point.startBtn.disabled = true;
		}
		if (reg.hasPerm("action.wsp.histo#change.comment")) {
			point.commentInput.onblur = point.updateMetaComment.bind(point);
		} else {
			point.commentInput.disabled = true;
		}
		return <div>
			<ShadowJsx skin="wed-histo-point/tooltip" skinOver="form-control-areas">
				{actionsBar}
				<div id="metas">
					{point.startBtn}
					{point.commentInput}
				</div>
				<div id="fields">
					<div class="field"><span class="label">Entrée du :</span><span class="value">{`${date} à ${time}`}</span></div>
					<div class="field"><span class="label">Modifié par :</span><span class="value"><UserRef î={{nickOrAccount: point.shortDesc.srcUser, reg} as OUserRefInit}/></span></div>
				</div>
			</ShadowJsx>
		</div>;
		// }
		// return null;
	}

	async updateMetaFlag() {
		try {
			await WSP.srcUpdateFields(this.histoPanel.reg.env.wsp, this, SRC.srcRef(this.shortDesc), {metaFlag: !this.shortDesc.metaFlag ? 1 : 0});
		} catch (e) {
			await ERROR.report("La modification de la marque de cette entrée a échoué.", e)
		}
		return this.histoPanel.updateHisto();
	}

	async updateMetaComment() {
		const v = this.commentInput.value;
		const metas: JSrcFields = {metaComment: v};
		if (!this.shortDesc.metaFlag && v && !this.shortDesc.metaComment) metas.metaFlag = 1; //Si meta nouvellement renseigné, on flag aussi
		try {
			await WSP.srcUpdateFields(this.histoPanel.reg.env.wsp, this, SRC.srcRef(this.shortDesc), metas);
		} catch (e) {
			await ERROR.report("L'enregistrement de la note pour cette entrée a échoué.", e)
		}
		return this.histoPanel.updateHisto();
	}
}

REG.reg.registerSkin("wed-histo-point/tooltip", 1, /* language=CSS */ `
	:host {
		display: flex;
		flex-direction: column;
	}

	c-bar-actions {
		border-bottom: 1px solid var(--border-color
		);
	}

	#metas {
		display: flex;
		margin: .5em 0;
	}

	#metaStar {
		margin: 1px;
		border: none;
	}

	#star {
		stroke: var(--fade-color);
		fill: var(--fade-color);
		opacity: .6;
	}

	#metaStar[aria-pressed=true] #star {
		stroke: var(--alt2-color);
		fill: var(--wsp-item-histo-star-bgcolor, #ffea00);
		opacity: unset;
	}

	#metaComment {
		flex: 1;
		min-width: 8em;
		max-width: 70vw;
		margin: 1px;
	}

	::placeholder {
		color: var(--fade-color);
		letter-spacing: 2px;
		font-size: var(--label-size);
		font-style: italic;
	}

	#fields {
		display: grid;
		min-width: 0;
		grid-template-columns: auto 1fr;
		grid-row-gap: .5em;
		grid-column-gap: 1em;
		padding: .5em;
	}

	.field {
		display: contents;
	}

	.value {
		color: var(--alt2-color);
		user-select: text;
	}
`);

customElements.define("wed-histo-point", HistoPoint);

class ShowHistoDiff extends Action<HistoPoint> {

	static SINGLETON = new ShowHistoDiff();

	constructor() {
		super("histoDiff");
		this._label = "Afficher les différences";
		this._icon = "/@skin@/edit/wed/diff/diff.svg";
	}

	isEnabled(ctx: HistoPoint): boolean {
		const house = ctx.histoPanel.wedMgr.docHolder.house as IWspXmlHouse;
		if (!house) return false;
		if (SRC.srcRef(ctx.shortDesc) === SRC.srcRef(house.srcFields)) return false; //c'est l'item courant, pas de diff avec lui-même !
		return super.isEnabled(ctx);
	}

	execute(ctx: HistoPoint, ev?: Event): any | "noPreventDefault" | "noStopPropag" | "noStopPropag-noPreventDefault" {
		const panel = ctx.histoPanel;
		panel.setDiffPoint(ctx);
		panel.closeTooltip();
	}
}

REG.reg.addToList("actions:item:histoEntry", "histoDiff", 1, ShowHistoDiff.SINGLETON);


class DeleteHistoEntry extends Action<HistoPoint> {

	static SINGLETON = new DeleteHistoEntry();

	constructor() {
		super("delEntry");
		this._label = "Supprimer définitivement cette entrée";
		this._icon = "/@skin@/commons/icons/delete.svg";
		this._group = "delete";
	}

	isEnabled(ctx: HistoPoint): boolean {
		if (!ITEM.isHistoryUri(ctx.shortDesc.srcUri)) return false; //c'est l'item live.
		if (ctx.histoPanel.reg.env.longDesc.srcUri === ctx.shortDesc.srcUri) return false; //c'est l'item courant.
		return super.isEnabled(ctx);
	}

	checkObjectRootPerm(ctx: HistoPoint, perms?: string | string[]): boolean {
		const histoPanel = ctx.histoPanel;
		return histoPanel.reg.hasPerm(ctx.shortDesc.srcUser === histoPanel.reg.env.securityCtx.account ? "action.wsp.histo#deletePermanently.mine" : "action.wsp.histo#deletePermanently");
	}

	async execute(ctx: HistoPoint, ev?: Event) {
		const panel = ctx.histoPanel;
		panel.closeTooltip();
		const dt = new Date(ctx.shortDesc.srcDt);
		const date = dt.toLocaleDateString("fr");
		const time = dt.toLocaleTimeString("fr");
		if (await POPUP.confirm(`Souhaitez-vous vraiment supprimer définitivement cette entrée d'historique du ${date} à ${time} ?`, ctx, {okLbl: "Supprimer définitivement"})) {
			await WSP.srcDeletePermanently(panel.reg.env.wsp, ctx, [ctx.shortDesc.srcUri]);
			return panel.updateHisto();
		}
	}
}


REG.reg.addToList("actions:item:histoEntry", "delEntry", 1, DeleteHistoEntry.SINGLETON);


class OpenHistoEntry extends Action<HistoPoint> {

	static SINGLETON = new OpenHistoEntry();

	constructor() {
		super("openEntry");
		this._label = "Visualiser cette entrée";
		this._icon = "/@skin@/wsp/actions/openItem.svg";
		this._group = "open";
	}

	isEnabled(ctx: HistoPoint): boolean {
		if (!ITEM.isHistoryUri(ctx.shortDesc.srcUri)) return false; //c'est l'item live.
		if (ctx.histoPanel.reg.env.longDesc.srcUri === ctx.shortDesc.srcUri) return false; //c'est l'item courant.
		return super.isEnabled(ctx);
	}

	async execute(ctx: HistoPoint, ev?: Event) {
		const panel = ctx.histoPanel;
		panel.closeTooltip();

		const title = ITEM.getItemUriLabel(ctx.shortDesc.srcUri, ctx.shortDesc);
		const dt = new Date(ctx.shortDesc.srcDt);
		const date = dt.toLocaleDateString("fr");
		const time = dt.toLocaleTimeString("fr");

		if (!_ItemIsolated) _ItemIsolated = (await import("back/wsp/views/itemIsolated.js")).ItemIsolated;

		POPUP.showDialog(new _ItemIsolated().initialize({
				reg: ctx.histoPanel.reg.env.wsp.reg,
				srcRef: SRC.srcRef(ctx.shortDesc)
			}),
			ctx,
			{
				initWidth: "80%",
				initHeight: "80%",
				titleBar: {barLabel: {label: `${title} du ${date} à ${time}`}},
				resizer: {}
			})
	}
}

let _ItemIsolated: typeof ItemIsolated;


REG.reg.addToList("actions:item:histoEntry", "openEntry", 1, OpenHistoEntry.SINGLETON);


/**
 *
 */
export class OtherItemDiffPanel extends DiffPanelBase<IItemUiEnv> {

	action: OtherItemDiffAction;

	diffMode: EXmlDiffMode;
	diffModeBtn: ButtonActions<OtherItemDiffPanel>;
	srcDiff: SrcPointer;

	initPanel(action: OtherItemDiffAction, bar: IWedDiffBar): this {
		this._initPanel(action, bar);
		this.diffMode = EXmlDiffMode.diff;
		this.srcDiff = new SrcPointer().initialize({
			reg: this.reg as IReg<IWspUiEnv>,
			defaultAction: SrcPointerFastSelect.SINGLETON,
			actionsLists: ["actions:wsp:wed:otherItemDiff", "actions:wsp:shortDesc"],
			accelKeysLists: ["accelkeys:wsp:wed:otherItemDiff", "accelkeys:wsp:shortDesc"],
			draggable: true,
			dropable: true
		});
		this.srcDiff.onSrcRefChange.add(this.onSrcDiffChange);
		this.diffModeBtn = new ButtonActions<OtherItemDiffPanel>().initialize({
			reg: this.reg,
			label: diffModeActions[0].getLabel(this),
			actions: diffModeActions,
			actionContext: this
		});
		this.shadowRoot.append(
			this.srcDiff,
			this.result,
			this.diffModeBtn
		);
		return this;
	}

	setDiff(params: JOtherItemWedDiffBarParams | null): void {
		this.srcDiff.setSrcRef(params?.srcDiff);
		if (params) this.diffMode = params.mode || EXmlDiffMode.diff;
		diffModeActions[this.diffMode === EXmlDiffMode.diff ? 0 : 1].execute(this);
	}

	buildDiffParams(): JOtherItemWedDiffBarParams {
		return {diffId: this.action.getId(), srcDiff: this.srcDiff.srcRef, mode: this.diffMode}
	}

	async execDiff(): Promise<void> {
		const sd = this.srcDiff.shortDesc;
		if (sd) {
			const itemType = this.reg.env.wsp.wspMetaUi?.getItemType(sd.itModel);
			if (itemType) return callDiff(itemType.getMainXmlSrcUri(sd), this, this.diffMode);
		}
		return callDiff(null, this, this.diffMode);
	}

	protected onSrcDiffChange(this: void, drawer: SrcPointer) {
		DOMSH.findHost<OtherItemDiffPanel>(drawer).execDiff();
	}
}

function execDiff(this: Action<OtherItemDiffPanel>, ctx: OtherItemDiffPanel) {
	ctx.diffMode = this.getId() === "diff" ? EXmlDiffMode.diff : EXmlDiffMode.patch;
	ctx.diffModeBtn.label = this.getLabel(ctx);
	if (!ctx.srcDiff.fetchPending) ctx.execDiff();
}

const diffModeActions = [
	new Action<OtherItemDiffPanel>("diff").setLabel("Mode écarts").setExecute(execDiff),
	new Action<OtherItemDiffPanel>("patch").setLabel("Mode contributions").setExecute(execDiff)
];


REG.reg.registerSkin("wed-diff-otheritem", 1, /* language=CSS */ `
	:host {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}

	wsp-src-pointer {
		flex: 1 1 auto;
		align-items: center;
	}

	#result {
		flex: 1 1 auto;
	}
`);

function addAction(action: Action<IShortDescCtx>, accel?: string) {
	REG.reg.addToList("actions:wsp:wed:otherItemDiff", action.getId(), 1, action);
	if (accel) REG.reg.addToList("accelkeys:wsp:wed:otherItemDiff", accel, 1, action);
}

addAction(SrcPointerFastSelect.SINGLETON, "Enter");
addAction(SrcPointerPaste.SINGLETON, "v-accel");
addAction(new SrcPointerErase(), "Delete");

customElements.define("wed-diff-otheritem", OtherItemDiffPanel);

/**
 *
 * @param srcRef
 *  si "" pas de source de diff, mais un simple refresh pourait en proposer un
 *  si null pas de source de diff et aucune actuellement disponible (action user de sélection nécessaire).
 */
export async function callDiff(srcRef: srcRef | "" | null, panel: DiffPanelBase<IItemUiEnv>, mode: EXmlDiffMode) {
	try {
		if (srcRef) {
			panel.updateDiffResult("computing");
			const dom = await fetchDiff(panel.wedMgr, panel.reg.env.wsp.code, srcRef);
			//console.log(":::execDiff:::", dom);
			if (dom) {
				const session = new XmlDiffSession(dom, mode, panel.wedMgr.docHolder.getSubRoot());
				panel.wedMgr.docHolder.setDiffSession(session);
				panel.updateDiffResult(session.diffFound);
			} else {
				panel.wedMgr.docHolder.setDiffSession(null);
				panel.updateDiffResult("error");
			}
		} else {
			panel.wedMgr.docHolder.setDiffSession(null);
			panel.updateDiffResult(srcRef === "" ? "computable" : null);
		}
	} catch (e) {
		ERROR.log("Diff failed", e);
		panel.wedMgr.docHolder.setDiffSession(null);
		panel.updateDiffResult("error");
	}
}

async function fetchDiff(wedMgr: WedMgr, candidateWspCd: wspCd, candidateRef: srcRef | ESpecialCandidateUri, tries?: number): Promise<Document> {
	const reg = wedMgr.reg;
	const wsp = reg.env.wsp;
	const srcFields = (wedMgr.docHolder.house as IWspXmlHouse).srcFields;
	const srcRef = ITEM.isHistoryOrTrashUri(srcFields.srcUri) ? srcFields.srcUri : SRC.srcRef(srcFields);
	const wspRef = WSP.buildWspRef(wsp.code, srcRef);
	if (reg.env.place.isHouseDirty(wspRef)) await reg.env.place.wspsLive.saveHouse(wspRef);
	const doc = await WSP.fetchDiff(reg.env.wsp, reg.env.uiRoot, srcRef, candidateWspCd, candidateRef);
	const sd = reg.env.place.wspsLive.getHouseIfFetched(wspRef)?.srcFields;
	if (sd && (sd.srcStamp ? sd.srcStamp !== doc.documentElement.getAttribute("srcStamp") : sd.srcDt !== Number.parseInt(doc.documentElement.getAttribute("srcDt")))) {
		//La base comparée n'est pas en phase avec notre item actuel.
		if (tries === 2) {
			//toujours pas bon après un 1er refetch, on tente un reload complet de la house.
			reg.env.place.wspsLive.reloadHouse(wspRef);
			return null; //l'ihm est reconstruit le diff sera réappelé après redraw.
		}
		// if (tries > 3) { JAMAIS appelé car quand tries === 2, car refresh ui complet.
		// 	ERROR.log("fetchDiff: item out of sync after 3 tries");
		// 	POPUP.showNotifError("Impossible d'effectuer la comparaison", reg.env.uiRoot);
		// 	return null;
		// }
		return fetchDiff(wedMgr, candidateWspCd, candidateRef, (tries || 0) + 1);
	}
	return doc;
}
